/**
 * Bubble the specified error to the top/window, in it's
 * own execution stack.
 *
 * This appears to the best way to report an error to the console.
 *
 * Note: Don't use "console.error", it's not standard.
 * The top-most stack frame references the invocation of "console.error"
 * which is useless when debugging.
 */
module.exports = function (e) {
  setTimeout(() => {
    throw e;
  }, 0);
};


// WEBPACK FOOTER //
// ./~/@atlassiansox/experiment-common-core/lib/bubble-up-error.js